import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../../assets/images/Logo.svg'
import '../../assets/css/bootstrap.min.css'
import '../../assets/css/style.css'
import '../../assets/css/legal-pages.css'

interface PublicLegalLayoutProps {
  children: React.ReactNode
}

/**
 * Full-page layout for public legal pages (About Us, Terms, Privacy)
 * Matches Bnat branding with header and footer
 */
export default function PublicLegalLayout({ children }: PublicLegalLayoutProps) {
  return (
    <div className="public-legal-page">
      <header className="legal-page-header">
        <div className="container">
          <Link to="/" className="logo-link">
            <img src={logo} alt="Bnat" className="img-fluid" style={{ maxHeight: '40px' }} />
          </Link>
          <Link to="/" className="back-btn">
            ← Back to Home
          </Link>
        </div>
      </header>

      <main>{children}</main>

      <footer className="legal-page-footer">
        <div className="container">
          <p className="mb-2">© {new Date().getFullYear()} Bnat. All rights reserved.</p>
          <p className="mb-0">
            <Link to="/terms-condition">Terms and Conditions</Link>
            {' · '}
            <Link to="/privacy-policy">Privacy Policy</Link>
            {' · '}
            <Link to="/about-us">About Us</Link>
          </p>
        </div>
      </footer>
    </div>
  )
}
